import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const linkGroups = [
  {
    title: "站内导航",
    links: [
      { label: "首页", to: "/" },
      { label: "影视资讯", to: "/news" },
      { label: "关于本站", to: "/about" },
      { label: "常见问题", to: "/faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-300/60">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 min-w-0">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-foreground-950 text-lg">
                <i className="ri-film-line" />
              </span>
              <span className="font-heading text-base tracking-[0.14em] text-foreground-950">
                日韩黄色电影
              </span>
            </div>
            <p className="mt-4 max-w-[440px] text-sm leading-relaxed text-foreground-500">
              日韩情色影视资源与资讯平台。我们整理日韩地区情感类电影的剧情简介、创作背景与演职员信息，
              帮助成年观众更系统地了解这一类型的影视创作。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-primary-500/10 border border-primary-500/30 text-[11px] text-primary-700">
              <i className="ri-error-warning-line" />
              本站内容仅面向 18 岁以上成年用户
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title} className="min-w-0">
              <h4 className="font-label text-xs tracking-[0.2em] uppercase text-foreground-700">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="min-w-0">
            <h4 className="font-label text-xs tracking-[0.2em] uppercase text-foreground-700">
              影片分类
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {categories.slice(0, 4).map((category) => (
                <li key={category.type}>
                  <Link
                    to={`/category/${category.type}`}
                    className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 leading-relaxed">
            © 2026 日韩黄色电影 · 站内影片、影人与资讯均为虚构演示内容，不提供任何播放与下载资源。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line" />
              contact@jkcinema-demo.com
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}